import { Pipe, PipeTransform } from '@angular/core';
import {
  COMPANY_CONNECTION_STATUS_LABEL,
  INSTALLER_CONNECTION_STATUS_LABEL,
} from '../../domains/users/connection/connection-status.maps';
import { ConnectionStatus, Source } from '../../domains/users/connection/connection.model';

export interface ConnectionLike {
  status: ConnectionStatus;
  source?: Source;
}

/**
 * TT-192. An installer's own request is PENDING with source INSTALLER: it is
 * waiting on the company, the reverse of a company invite waiting on the installer.
 */
const REQUEST_LABEL = { company: 'Wants to connect', installer: 'Request sent' };

const isInstallerRequest = (like: ConnectionLike) =>
  like.source === Source.Installer && like.status === ConnectionStatus.Pending;

export const connectionStatusLabel = (like: ConnectionLike, mode: 'company' | 'installer'): string =>
  like
    ? isInstallerRequest(like)
      ? REQUEST_LABEL[mode]
      : mode === 'company'
      ? COMPANY_CONNECTION_STATUS_LABEL[like.status]
      : INSTALLER_CONNECTION_STATUS_LABEL[like.status]
    : '...';

@Pipe({ name: 'connectionStatusLabel' })
export class ConnectionStatusLabelPipe implements PipeTransform {
  transform(like: ConnectionLike, mode: 'company' | 'installer'): string {
    return connectionStatusLabel(like, mode);
  }
}
